import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Tabs, Tab, IconButton, Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Breadcrumb from 'src/components/Breadcrumb';
import { insuranceDetailTabsIndex } from 'src/utils/constants/insurance';
import { clearEquipmentOptions, loadInsuranceEquipments } from 'src/store/actions/insuranceActions';
import GeneralView from './General';
import EquipmentsView from './Equipments';
import useStyles from './styles';
import Toolbar from './Toolbar';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

export default function InsuranceTabs({ insurance }) {
  const navigate = useNavigate();
  const { tab } = useParams();
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState(false);

  const handleChange = useCallback(
    (_, newValue) => {
      setValue(newValue);
      navigate(`/insurances/list/${insurance?.policyId}/${newValue}`);
            dispatch(clearEquipmentOptions());
      
      if (newValue === insuranceDetailTabsIndex.EQUIPMENTS) {
        dispatch(loadInsuranceEquipments({ policyId: insurance?.policyId }));
      }
    },
    [setValue, navigate, insurance?.policyId, dispatch]
  );

  useEffect(() => {
    if (insurance?.policyId && !tab) {
      setValue(insuranceDetailTabsIndex.GENERAL);
    }
    if (tab) {
      if (Object.values(insuranceDetailTabsIndex).includes(tab)) {
        setValue(tab);
        dispatch(clearEquipmentOptions());
        if (tab === insuranceDetailTabsIndex.EQUIPMENTS) {
          dispatch(loadInsuranceEquipments({ policyId: insurance?.policyId }));
        }
      } else {
        navigate(`/insurances/list/${insurance?.policyId}`);
      }
    }
  }, [insurance?.policyId, tab, navigate, dispatch]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Breadcrumb />
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <IconButton onClick={() => navigate(-1)} color="primary" component="span">
          <ArrowLeft />
        </IconButton>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={value}
          onChange={handleChange}
        >
          <Tab
            label={t('COMMON.GENERAL')}
            value={insuranceDetailTabsIndex.GENERAL}
            className={classes.tab}
          />
          <Tab
            label={t('INSURANCE_VIEW.EQUIPMENTS')}
            value={insuranceDetailTabsIndex.EQUIPMENTS}
            className={classes.tab}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={insuranceDetailTabsIndex.GENERAL}>
        <GeneralView insurance={insurance} />
      </TabPanel>
      <TabPanel
        value={value}
        index={insuranceDetailTabsIndex.EQUIPMENTS}
        sx={{ mt: 3 }}
      >
        <Toolbar />
        <EquipmentsView insurance={insurance} />
      </TabPanel>
    </Box>
  );
}

InsuranceTabs.propTypes = {
  insurance: PropTypes.object.isRequired
};
